import React, { Component } from 'react';
import OptionalPackage from './Options/OptionalPackage';

class OptionalPackages extends Component {
	render() {
		const { lineInfo, lineIndex, planFeature, handleOptionalPackagesCheckbox, accountInitialStatus } = this.props;

		return (
			<div className="plan-section">
				<h5>Optional Packages</h5>
				{planFeature.map((featurePackage) => (
					<div className="package-wrapper" key={featurePackage.featurePackageId}>
						<div className="row">
							<div className="col col-md-5">
								<h6>
									<a
										onClick={() =>
											handleOptionalPackagesCheckbox(featurePackage.featurePackageId, lineIndex, {
												featurePackageId: featurePackage.featurePackageId,
												featurePackageDescription: featurePackage.description,
												featurePackageNote: featurePackage.note,
												...featurePackage.featurePackageOptions[0]
											})}
										className={
											lineInfo.features.findIndex(
												(x) => x.featurePackageId === featurePackage.featurePackageId
											) !== -1 ? (
												'btn-toggle-package package-enabled'
											) : (
												'btn-toggle-package'
											)
										}
									>
										{lineInfo.features.findIndex(
											(x) => x.featurePackageId === featurePackage.featurePackageId
										) !== -1 ? (
											<i className="fas fa-toggle-on" />
										) : (
											<i className="fas fa-toggle-off" />
										)}
										{featurePackage.description}
									</a>
								</h6>
								{featurePackage.note}
							</div>
							<div className="col col-md-7">
								{featurePackage.featurePackageOptions.map((packageOption) => (
									<OptionalPackage
										packageOption={packageOption}
										featurePackage={featurePackage}
										key={packageOption.featurePackageOptionId}
										accountInitialStatus={accountInitialStatus}
										{...this.props}
									/>
								))}
							</div>
						</div>
					</div>
				))}
			</div>
		);
	}
}

export default OptionalPackages;
